import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    const token = this.storageService.getToken();
    console.log('[AuthGuard] token present:', !!token);
    return true;
  }
}
